module.exports = __webpack_public_path__ + "img/jt.a7b91b7b.png";